import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	NbButtonModule,
	NbFormFieldModule,
	NbIconModule,
	NbInputModule
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { TextInput } from './../../../models/inputs/text-input';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-textbox-input',
	template: `
		<ng-container
			[ngTemplateOutlet]="
				control.type === 'password'
					? passwordInputTemplate
					: inputTemplate
			"
		></ng-container>

		<ng-template #passwordInputTemplate>
			<nb-form-field>
				<input
					[autocomplete]="control.autocomplete ?? ''"
					[attr.id]="controlId"
					nbInput
					fieldSize="medium"
					fullWidth
					[status]="control.colorStatus"
					[type]="showPassword ? 'text' : 'password'"
					[placeholder]="control.placeholder | translate"
					[formControl]="control"
				/>
				<button
					type="button"
					nbSuffix
					nbButton
					ghost
					(click)="showPassword = !showPassword"
				>
					<nb-icon
						[icon]="
							showPassword ? 'eye-off-2-outline' : 'eye-outline'
						"
						pack="eva"
						[attr.aria-label]="
							showPassword ? 'hide password' : 'show password'
						"
					>
					</nb-icon>
				</button>
			</nb-form-field>
		</ng-template>

		<ng-template #inputTemplate>
			<input
				[autocomplete]="control.autocomplete ?? ''"
				[attr.id]="controlId"
				nbInput
				fieldSize="medium"
				fullWidth
				[status]="control.colorStatus"
				[type]="control.clearable ? 'search' : control.type"
				[placeholder]="control.placeholder | translate"
				[formControl]="control"
			/>
		</ng-template>
	`,
	standalone: true,
	imports: [
		NgTemplateOutlet,
		NbFormFieldModule,
		NbInputModule,
		ReactiveFormsModule,
		NbButtonModule,
		NbIconModule,
		TranslateModule
	]
})
export class TextboxInputComponent extends BaseInputComponent {
	@Input({ required: true }) override control: TextInput;

	showPassword = false;
}
